<template>
    <div id="document-tags-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Document Tags</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="error" class="text-danger">{{ error }}</div>                    
                    <div class="d-flex flex-row">
                        <div class="flex-grow-1 mr-1">                                              
                            <input type="text" id="tagInput" class="form-control form-control-sm" list="tag-options" pattern="[a-zA-Z0-9 _-]" @keydown="validateKey($event)" v-model="tag" maxlength="25" />
                            <datalist id="tag-options">
                                <option v-for="option in options" :key="'document-tag-option-' + option.tag" :value="option.tag">{{ option.tag }}</option>
                            </datalist>
                        </div>                        
                        <div>
                            <button type="button" class="btn btn-primary btn-sm" @click="add()" :disabled="disabled">Add</button>
                        </div>
                    </div>
                    <div class="text-muted font-small-italic">*Tags should be one or two words limited to 25 alphanumeric characters and may contain spaces, underscores, and hyphens.</div>                   
                    <div v-if="message" :class="['h5 text-muted text-center mt-3']">
                        <i v-if="!messageClass" class="fas fa-spinner fa-spin "></i>
                        <span :class="messageClass">{{ message }}</span>
                    </div>
                    <div v-else>
                        <div v-for="tag in tags" :key="'document-tag-' + tag.tag" class="badge border mt-3 mr-2">
                            <button type="button" class="close" aria-label="Close" @click="remove(tag)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <span class="text-capitalize" v-tooltip:top="{creator: tag.creator, created_at: localize(tag.created_at)}">{{ tag.tag }}</span>             
                        </div>
                    </div>             
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DocumentType } from '../../constants.js';

export default {
    data() {
        return {
            clientId: null,
            claimId: null,
            id: null,
            documentTypeId: null,
            historical: false,
            options: [],
            tags: [],
            tag: null,

            message: null,
            messageClass: null,
            error: null,

            DocumentType: DocumentType
        }
    },
    computed: {
        href: function () {

            let retval = null;

            if (this.historical) {

                // NOTE: this assumes historical CMS documents will always have a service form
                if ([DocumentType.CMS_1500, DocumentType.CMS_1450, DocumentType.CMS_FORM].includes(this.documentTypeId)) {
                    retval = `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/services/${this.id}/tags`;
                }
                else {
                    retval = `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/documents/${this.id}/tags`;
                }    
            }
            else {

                if ([DocumentType.LWC_FORM_1008, DocumentType.LWC_FORM_1008_FINAL].includes(this.documentTypeId)) {
                    retval = `/ajax/attorney/claims/${this.claimId}/documents/${this.id}/tags`;
                }
                else {
                    retval = `/ajax/claims/${this.claimId}/documents/${this.id}/tags`;                    
                }                
            }
            
            return retval;
        },
        disabled: function () {

            const regex = /[^a-zA-Z0-9 _-]/;
            let invalid = regex.test(this.tag);
            if (invalid) {
                this.error = "The tag contains invalid characters.";
            } 
            else {
                this.error = null;
            }

            return !this.tag || invalid;
        }
    },
    methods: {
        show: function (clientId, claimId, id, documentTypeId, historical) {

            this.clientId = clientId;
            this.claimId = claimId;
            this.id = id;
            this.documentTypeId = documentTypeId;
            this.historical = historical;
            this.options = [];
            this.tags = [];
            this.tag = null;

            this.message = null;
            this.messageClass = null;
            this.error = null;

            $('#document-tags-modal').modal('show');
            this.listen();
            this.refresh();
        },
        listen: function () {

            let channel = this.historical ? 
                `historical-document-tags-event.service.${this.id}.${this.clientId}` :
                `document-tags-event.document.${this.id}.${this.clientId}`;

            // listen for document tag events
            window.Echo.private(channel)
                .listen('DocumentTagsEvent', (e) => {

                    if (this.id === e.id) {
                        this.refresh();
                    }
                });
        },
        refresh: function () {

            this.message = 'Loading...';
            axios.get(this.href)
                .then(response => {
            
                    this.options = response.data.options;
                    this.tags = response.data.tags;

                    // wait for next dom to be updated before clearing the message
                    this.$nextTick(() => {
                        this.message = null;            
                    });
                })
                .catch(error => {
                    this.messageClass = 'text-danger';
                    this.message = `Unable to load document tags. ${error.response.data.message}`;
                });
        },
        validateKey: function (e) {

            if (e.key.match(/[^a-zA-Z0-9 _-]/)) {
                e.preventDefault();
            }
        },
        add: function () {

            let tag = this.tag.trim();
            if (tag.length && !this.tags.some(e => e.tag.toLowerCase() === tag.toLowerCase())) {

                // if we find this tag in the options list use it otherwise create a new one
                let option = this.options.find(e => e.tag.toLowerCase() === tag.toLowerCase());
                if (!option) {
                    option = { id: null, tag: tag };
                }

                // add the tag to our list of tags
                this.message = 'Saving...';
                axios.post(this.href, {
                    tag: option
                })
                .catch(error => {
                    this.messageClass = 'text-danger';
                    this.message = error.response.data.message;
                });
            }

            this.tag = null;
        },
        remove: function (tag) {

            // remove the tag from our list of tags
            this.message = 'Removing...';            
            axios.delete(`${this.href}/${tag.id}`)
            .catch(error => {
                this.messageClass = 'text-danger';
                this.message = error.response.data.message;
            });
        },
        localize: function (value) {
            return this.$options.filters.localizeTime(value, 'YYYY-MM-DD HH:mm');
        }
    },
    mounted: function () {
        $('#document-tags-modal').on('shown.bs.modal', function (e) {
            $('#tagInput').focus();
        });
    },
    created() {
        eventHub.$on('show-document-tags', this.show);   
    },
    beforeDestroy() {
        eventHub.$off('show-document-tags');
    },
    directives: {
        tooltip: function (el, binding) {

            if (binding.value.creator) {

                if ($(el)) { $(el).popover('dispose'); }

                $(el).popover({
                    content:  '<small>Created by: ' + binding.value.creator + '<br/>' + 'Created at: ' + binding.value.created_at + '</small>',
                    placement: binding.arg,
                    trigger: 'hover',
                    html: true
                });
            }
        }              
    }  
}
</script>

<style scoped>
    .badge {
        padding: 10px;
        font-size: .9em;
    }

    .badge .close {
        margin-left: .25rem;
        color: inherit;
        font-size: 100%;
        text-shadow: 0 1px 0 rgba(#000, .5);
    }

    .font-small-italic {
        font-size: .75em;
        font-style: italic;
    }        
</style>